import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

const AutoLogout = () => {
    const navigate = useNavigate();
    const logoutTimer = useRef<any>(null);
    const [showModal, setShowModal] = useState(false);

    const handleUserActivity = () => {
        clearTimeout(logoutTimer.current);
        logoutTimer.current = setTimeout(() => {
            // Implement logout functionality here
            console.log('User logged out due to inactivity.');
            // Example: Clear user session and redirect to login page
            setShowModal(true); // Show modal after inactivity  
            sessionStorage.clear();
        }, 1200000); // 20 minutes in milliseconds
    };

    useEffect(() => {
        // Add event listeners for various user activities
        window.addEventListener('mousemove', handleUserActivity);
        window.addEventListener('keypress', handleUserActivity);
        window.addEventListener('click', handleUserActivity);
        window.addEventListener('scroll', handleUserActivity, true); // Capturing scroll activity

        // Cleanup function to remove event listeners
        return () => {
            window.removeEventListener('mousemove', handleUserActivity);
            window.removeEventListener('keypress', handleUserActivity);
            window.removeEventListener('click', handleUserActivity);
            window.removeEventListener('scroll', handleUserActivity);
            clearTimeout(logoutTimer.current);
        };
    }, []);
    const handleLogout = () => {
        navigate('/login');
    };
    //return null; // This component doesn't render anything
    return (
        <>
            <Modal
                isOpen={showModal}
                fade={true}
                className="modal-dialog modal-dialog-centered"
                style={{ minWidth: 800, maxWidth: 800 }}
                contentClassName="modal-content"
                zIndex={"100000"}
                centered={true}
            >
                <div className="modal-header">
                    <h5 className="modal-title">Your session has expired</h5>
                </div>
                <ModalBody>
                    <div className="forms-sample">
                        <div className="row">
                            <p style={{ textAlign: "center" }}>Your login session has expired. Please login again.</p>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="button" onClick={() => { handleLogout(); }} className="btn btn-success text-white">Logout</button>
                </ModalFooter>
            </Modal>
        </>
    )
};

export default AutoLogout;